letterAdjust.scale = 0.7;
letterAdjust.svg.top = 11;
letterAdjust.y = 2;
var font = {
    ".": "M371-410v317h317v-317H371z",
    "0": "M369 -240v1708q0 70 50 120t120 50h569q70 0 120 -50t50 -120v-1708q0 -70 -50 -120t-120 -50h-569q-70 0 -120 50.5t-50 119.5zM711 -125h227v1479h-227v-1479z",
    "1": "M336 1122v90l151 426h304v-2048h-340v1532h-115z",
    "2": "M369 -203l569 1172v385h-227v-385h-342v499q0 70 50 120t120 50h569q70 0 120 -50t50 -120v-464q0 -47 -14.5 -111t-34.5 -107l-443 -911h492v-285h-909v207z",
    "3": "M369 -240v525h342v-410h227v555l-320 197v51l320 196v480h-227v-385h-342v499q0 70 50 120t120 50h569q70 0 120 -50t50 -120v-600q0 -35 -20.5 -73.5t-51.5 -57.5l-137 -84l137 -86q31 -18 51.5 -56t20.5 -75v-676q0 -70 -50 -120t-120 -50h-569q-70 0 -120 50.5 t-50 119.5z",
    "4": "M274 8v111l455 1519h342l-403 -1345h176v512h340v-512h114v-285h-114v-418h-340v418h-570z",
    "5": "M369 -240v525h342v-410h227v739h-569v1024h909v-284h-567v-455h397q70 0 120 -50t50 -120v-969q0 -70 -50 -120t-120 -50h-569q-70 0 -120 50.5t-50 119.5z",
    "6": "M369 -240v1708q0 70 50 120t120 50h569q70 0 120 -50t50 -120v-499h-340v385h-227v-598h397q70 0 120 -50.5t50 -119.5v-826q0 -70 -50 -120t-120 -50h-569q-70 0 -120 50.5t-50 119.5zM711 -125h227v598h-227v-598z",
    "7": "M348 1067v571h909v-321l-389 -1727h-350l400 1764h-228v-287h-342z",
    "8": "M369 -240v676q0 37 21.5 75t49.5 56l140 86l-140 84q-29 18 -50 57.5t-21 73.5v600q0 70 50 120t120 50h569q70 0 120 -50t50 -120v-600q0 -35 -20.5 -73.5t-51.5 -57.5l-137 -84l137 -86q31 -18 51.5 -56t20.5 -75v-676q0 -70 -50 -120t-120 -50h-569q-70 0 -120 50.5 t-50 119.5zM711 -125h227v555l-115 72l-112 -72v-555zM711 874l112 -69l115 69v480h-227v-480z",
    "9": "M369 -240v525h342v-410h227v598h-399q-70 0 -120 50t-50 120v825q0 70 50 120t120 50h569q70 0 120 -50t50 -120v-1708q0 -70 -50 -120t-120 -50h-569q-70 0 -120 50.5t-50 119.5zM711 756h227v598h-227v-598z",
    "A": "M309 -403l363 2041h309l360 -2041v-7h-313l-49 394h-311l-50 -394h-309v7zM700 225h246l-125 949z",
    "B": "M371 -410v2048h716q106 0 157.5 -43t51.5 -131v-544q0 -76 -24.5 -114t-93.5 -79l-111 -63l119 -68q70 -43 95.5 -84t25.5 -115v-633q0 -88 -52 -131t-161 -43h-723zM688 -176h297v635l-133 84h-164v-719zM688 778h160l131 86v541h-291v-627z",
    "C": "M369 -236v1700q0 88 50 131t156 43h519q213 0 213 -174v-485h-320v424h-301v-1577h301v450h320v-512q0 -174 -213 -174h-519q-106 0 -156 43t-50 131z",
    "D": "M371 -410v2048h596q172 0 262 -74.5t90 -211.5v-1475q0 -139 -91 -213t-261 -74h-596zM688 -174h170q141 0 141 108v1360q0 53 -35.5 81t-99.5 28h-176v-1577z",
    "E": "M371 -410v2048h749v-243h-432v-627h385v-242h-385v-692h440v-244h-757z",
    "F": "M371 -410v2048h751v-243h-434v-633h373v-240h-373v-932h-317z",
    "G": "M369 -236v1700q0 88 51 131t158 43h520q213 0 213 -174v-442h-322v381h-303v-1577h303v612h-172v240h494v-914q0 -174 -213 -174h-523q-106 0 -156 43t-50 131z",
    "H": "M371 -410v2048h317v-850h320v850h321v-2048h-321v945h-320v-945h-317z",
    "I": "M371 -410v2048h317v-2048h-317z",
    "J": "M315 -236v512h318v-450h268v1812h320v-1874q0 -88 -51 -131t-160 -43h-486q-209 0 -209 174z",
    "K": "M371 -410v2048h317v-901l287 901h338v-10l-350 -979l389 -1048v-11h-344l-320 955v-955h-317z",
    "L": "M371 -410v2048h317v-1798h402v-250h-719z",
    "M": "M371 -410v2048h311q281 -1018 285 -1122q0 45 72.5 325.5t142.5 538.5l71 258h314v-2048h-314v1008l-196 -799h-180l-195 799v-1008h-311z",
    "N": "M371 -410v2048h295l383 -1108v1108h309v-2048h-293l-383 1115v-1115h-311z",
    "O": "M369 -236v1700q0 174 206 174h543q106 0 157.5 -43t51.5 -131v-1700q0 -88 -51.5 -131t-157.5 -43h-543q-207 0 -206 174zM686 -174h320v1577h-320v-1577z",
    "P": "M371 -410v2048h716q211 0 211 -174v-938q0 -174 -211 -174h-399v-762h-317zM688 588h291v815h-291v-815z",
    "Q": "M369 -233v1697q0 88 51 131t158 43h538q109 0 159 -43t50 -131v-1534l119 -84v-256h-25l-112 86l-9 -10q-45 -74 -182 -74h-543q-104 0 -154 43t-50 132zM686 -172h320v88l-142 104v256h21l121 -86v1213h-320v-1575z",
    "R": "M371 -410v2048h727q211 0 211 -174v-755q0 -80 -41 -119t-125 -45h-76l291 -944v-11h-324l-274 918h-72v-918h-317zM688 727h301v676h-301v-676z",
    "S": "M369 -236v504h317v-444h291v424l-547 608q-39 39 -50 69.5t-11 88.5v450q0 88 51 131t158 43h507q211 0 211 -174v-475h-319v416h-291v-397l547 -609q39 -43 51 -72.5t12 -84.5v-478q0 -174 -211 -174h-507q-106 0 -157.5 43t-51.5 131z",
    "T": "M340 1395v243h893v-243h-289v-1805h-315v1805h-289z",
    "U": "M369 -236v1874h317v-1812h320v1812h321v-1874q0 -174 -213 -174h-536q-106 0 -157.5 43t-51.5 131z",
    "V": "M334 1632v6h319l191 -1497l188 1497h322v-6l-355 -2042h-315z",
    "W": "M338 1638h324l114 -1396l166 1396h258l164 -1400l117 1400h323l-270 -2048h-305l-156 1280l-160 -1280h-305z",
    "X": "M356 -401l324 1034l-301 997v8h328l165 -684l170 684h328v-8l-301 -995l324 -1036v-9h-336l-185 715l-182 -715h-334v9z",
    "Y": "M330 1630v8h327l193 -860l192 860h328v-8l-360 -1286v-754h-324v756z",
    "Z": "M360 -242l500 1631h-457v249h791v-182l-500 -1614h506v-252h-840v168z"
};
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 21,
    panel_Hor_Adjustment = -1.5,
    font_Top_Adjustment = -8,
    tracking = 1.5,
    middleSplitAdjustment = -1.25,
    middleSpreadAdjustment = {
        left: 1.25,
        right: 1.25
    },
    small_Caps_Adjustment = {
        vertical: -1675,
        horizontal: 550,
        scale_width: 0.75, // this effects with the numbers
        scale_height: 0.75, // this effects with the numbers
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#003E7E", // blue
            ],
            third: [
                "#f2e703", // blue
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#003E7E", // blue
            ],
            third: [
                "#f2e703", // blue
                "#da1a32",
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.2
        },
        numbers: {
            width: 1.5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 3, // this moves it up from the bottom
            horizontal: 0,
            scale_width: 31.5,
            scale_height: 31.5,
        },
        hyphen: {
            vertical: -8,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: -0.75, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 15,
        left: -7.5,
        width: 92,
        height: 70,
        middle_Space: 5,
        oneOffset: 6
    };
